import React from "react";
import { useReveal } from "../../lib/useReveal";

/** Fades/slides children in on first scroll into view. `index` staggers siblings. */
const Reveal = ({ as: Tag = "div", index = 0, fill = false, className = "", children, ...rest }) => {
  const [ref, shown] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${fill ? "reveal--fill" : ""} ${className}`.trim()}
      data-shown={shown}
      style={{ "--i": index }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
